import axiosInstance from '../../../../../utils/axios';
import { handleErrorExpireMarginBoost } from './errors';

const expireMarginBoost = async (
  marginBoostId: number,
  onSuccess: () => void,
  onError: (message: string) => void,
): Promise<void> => {
  try {
    const response = await axiosInstance.post(
      `/margin-boost/expire/${marginBoostId}`,
    );
    if (response.status === 200) {
      onSuccess();
    }
  } catch (error) {
    handleErrorExpireMarginBoost(error, onError);
    throw error;
  }
};

export default expireMarginBoost;
